import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import UseOfProceedsSF from '../../../components/superUser/loan/UseOfProceedsSF'
import UseOfProceedsNavUI from '../../../components/superUser/loan/UseOfProceedsNavUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import UseOfProceedsCreateModalSF from '../../../components/superUser/loan/UseOfProceedsCreateModalSF.js'

const UseOfProceedsPageUI = ({ context, errorList, loan, onRefreshClick, onCreateClick, onCancelClick, createMode, onSubmit, billList,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!billList || !errorList} loan={loan} page='proceeds' dimension='w768'
  >
    {
      (!billList || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      billList &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
            <span className='g_m_left_100 g_large'><b>Use of Proceeds (Final)</b></span>
          </span>
        }
        right={
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}} className='g_m_top_50'>
            <div className='g_m_bottom_50' style={{height: '1.5em'}}></div>
            <div style={{height: '1.5em'}}></div>
          </div>
        }
      />
    }
    {
      billList &&
      <UseOfProceedsNavUI loan={loan} page='proceeds' />
    }
    {
      billList && billList.length > 0 &&
      <UseOfProceedsSF
        context={context}
        loan={loan}
        onRefreshClick={onRefreshClick}
        billList={billList}
      />
    }
    {
      billList && billList.length === 0 &&
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No final use of proceeds'
      />
    }
    {
      loan &&
      <UseOfProceedsCreateModalSF
        context={context}
        createMode={createMode}
        loan={loan}
        onSubmit={onSubmit}
        onCancelClick={onCancelClick}
        onRefreshClick={onRefreshClick}
      />
    }
  </SuperUserLoanPageUI>

export default UseOfProceedsPageUI
